import { Component, OnInit } from '@angular/core';
import { UtilService } from '@app/utility/util.service'
import { ApiService } from '@app/utility/api.service'
import { MasterService } from '@app/utility/master.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { Observable } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '@env/environment';

declare var $: any;
enum CustomerType {
  Company = 1,
  Person = 2
};

@Component({
  selector: 'app-profile-register',
  templateUrl: './profile-register.component.html',
  styleUrls: ['./profile-register.component.scss']
})
export class ProfileRegisterComponent implements OnInit {

  Contact: any;
  CompanyTypeList: any;
  PersonTypeList: any;
  AddressList: any;
  DocumentList: any = [];
  FileList: any = [];
  AcceptExtension: any;
  MaxTotalSizeMB: number;
  Type: CustomerType = CustomerType.Company;
  ImageSrc: any;
  PortalLogin: any;

  AcceptChecked: Boolean = false;

  form: FormGroup;
  ticket: FormGroup;

  isShownConsent = false
  
  masterStatus: any

  constructor(
    private Fb: FormBuilder,
    private Util: UtilService,
    private Api: ApiService,
    private MasterService: MasterService,
    private Router: Router,
    private Sanitazer: DomSanitizer
  ) {
    this.form = this.Fb.group({
      "contactid": "",
      "dpa_contacttype": "",

      "dpa_personaltypeid": "",
      "dpa_personaltypeidname": "",
      "firstname": "",
      "lastname": "",
      "dpa_idcard": "",
      "dpa_passport": "",
      "birthdate": "",
      "telephone1": "",

      "dpa_accountno": "",

      "dpa_companytypeid": "",
      "dpa_companytypeidname": "",
      "dpa_companyname": "",
      "dpa_registrationid": "",
      "dpa_authorizedperson": "",
      "dpa_authorizedperson_idcard": "",
      "dpa_authorizedperson_telephone": "",

      "emailaddress1": "",

      "dpa_contact_homeno": "",
      "dpa_contact_moo": "",
      "dpa_contact_street": "",
      "dpa_contact_subdistict": "",
      "dpa_contact_subdistictname": "",
      "dpa_contact_distict": "",
      "dpa_contact_distictname": "",
      "dpa_contact_province": "",
      "dpa_contact_provincename": "",
      "dpa_contact_postcode": "",
      "dpa_contact_postcodename": "",
      "dpa_contact_country": "",
      "dpa_contact_countryname": "",
      "dpa_allowemail": "",
      "dpa_allowsms": "",

      "dpa_approvalticketid": "",
      "dpa_name": "",
      "dpa_contactid": "",
      "dpa_submitdate": "",
      "dpa_originalsource": "2",
      "dpa_approvalstatuscode": "01",
      "dpa_approvalstatusid": "",
      "dpa_documentchecklist": "",
      "dpa_attachsizing": "0",
      "dpa_agentbankflag": true,
      "dpa_portalflag": false,
      "attachfilelist": []
    });

    this.ticket = this.Fb.group({
      "dpa_approvalticketid": "",
      "dpa_name": "",
      "dpa_contactid": "",
      "dpa_submitdate": "",
      "dpa_originalsource": "2",
      "dpa_approvalstatuscode": "01",
      "dpa_approvalstatusid": "",
      "dpa_documentchecklist": "",
      "dpa_attachsizing": "0",
      "attachfilelist": []
    });
  }

  async ngOnInit() {
    const thisTs = this;
    // this.Util.ShowWaiting(true);

    function match(params: any, data: any) {
      if ($.trim(params.term) === '') {
        return data;
      }
      if (typeof data.text === 'undefined') {
        return null;
      }
      if (data.text.toLowerCase().indexOf(params.term.toLowerCase()) < 0)
        return null;
      else
        return data;
    }

    $('.selectCompany').select2({
      matcher: thisTs.MatchItem
    });

    $('.selectPerson').select2({
      matcher: thisTs.MatchItem
    });

    $('.selectAddress').select2({
      matcher: function (params: any, data: any) {
        if ($.trim(params.term) === '') {
          return data;
        }

        // Do not display the item if there is no 'text' property
        if (typeof data.text === 'undefined') {
          return null;
        }

        if (params.term.length > 1) {
          // `params.term` should be the term that is used for searching
          // `data.text` is the text that is displayed for the data object
          let cris = params.term.split(" ")
          let found = true
          for (var i = 0; i < cris.length; i++) {
            if (cris[i] != '' && data != null && data.text != null && data.text.toLowerCase().indexOf(cris[i].toLowerCase()) < 0) {
              found = false;
              return null
            }
          }
          if (found) {
            // You can return modified objects from here
            // This includes matching the `children` how you want in nested data sets
            return data;
          }
        }
        // Return `null` if the term should not be displayed
        return null;
      },
      placeholder: "โปรดพิมพ์รายละเอียดที่อยู่"
    });

    await this.InitDropdown()

    $('.selectAddress').on("change", function (e: any) {
      thisTs.AddressChange(e.target.value);
    });

    $('.selectCompany').on("change", function (e: any) {
      thisTs.CompanyTypeChange(e.target.value);
      $('.docCheck').on("change", function (e: any) {
        thisTs.SelectDocument(e.target);
      });
    });
    $('.selectPerson').on("change", function (e: any) {
      thisTs.PersonTypeChange(e.target.value);
      $('.docCheck').on("change", function (e: any) {
        thisTs.SelectDocument(e.target);
      });
    });

    this.AcceptExtension = environment.AcceptUploadFileExtension;
    this.MaxTotalSizeMB = await this.MasterService.GetMaxUploadFileSize();
    this.CreateTableFile();
    var TableDocs = $('#TableDocs');
    TableDocs.on('click', 'tbody tr td [role=view]', function () {
      thisTs.ViewFile($(this).attr('url'), $(this).attr('filename'));
    });

    TableDocs.on('click', 'tbody tr td [role=delete]', function () {
      thisTs.DeleteFile($(this).attr('filename'));
    });

    this.CompanyTypeChange($("#Type_Company").val());
    $('.docCheck').on("change", function (e: any) {
      thisTs.SelectDocument(e.target);
    });

    $("#dpa_idcard").on("keypress", function (e: any) {
      return thisTs.NumericKey(e);
    });
  }

  MatchItem(params: any, data: any) {
    if ($.trim(params.term) === '') {
      return data;
    }
    if (typeof data.text === 'undefined') {
      return null;
    }
    let found = true
    if (data.text.toLowerCase().indexOf(params.term.toLowerCase()) < 0)
      return null;
    else
      return data;
  }

  async InitDropdown() {
    
    this.Util.ShowWaiting(true)

    this.CompanyTypeList = JSON.parse(localStorage.getItem("companyType"));
    if(this.CompanyTypeList == null || this.CompanyTypeList.length == 0){
      this.CompanyTypeList = await this.Api.get("master", "companyType");
      localStorage.setItem("companyType", JSON.stringify(this.CompanyTypeList));
    }
    this.PersonTypeList = JSON.parse(localStorage.getItem("personalType"));
    if(this.PersonTypeList == null || this.PersonTypeList.length == 0){
      this.PersonTypeList = await this.Api.get("master", "personalType");
      localStorage.setItem("personalType", JSON.stringify(this.PersonTypeList));
    }
    this.AddressList = JSON.parse(localStorage.getItem("address"));
    if(this.AddressList == null || this.AddressList.length == 0){
      this.AddressList = await this.Api.getMasterAddress();
    localStorage.setItem("address", JSON.stringify(this.AddressList));
    }
    this.masterStatus = await this.Api.get("master", "approvalStatus")

    this.Util.ShowWaiting(false)
  }

  CustomerTypeChange(target: any) {
    let thisTs = this;
    this.ResetForm();
    if (target.id == "Person") {
      $("#divIndividual").removeClass("hidden");
      $("#divNonIndividual").addClass("hidden");
      this.PersonTypeChange($("#Type_Person").val());
      this.Type = CustomerType.Person;
      this.form.controls["dpa_companytypeid"].setValue("");
      this.form.controls["dpa_companytypeidname"].setValue("");
    }
    else {
      $("#divIndividual").addClass("hidden");
      $("#divNonIndividual").removeClass("hidden");
      this.CompanyTypeChange($("#Type_Company").val());
      this.Type = CustomerType.Company;
      this.form.controls["dpa_personaltypeid"].setValue("");
      this.form.controls["dpa_personaltypeidname"].setValue("");
    }
    $('.docCheck').on("change", function (e: any) {
      thisTs.SelectDocument(e.target);
    });
  }

  AddressChange(value: any) {
    if (this.AddressList == null)
      return;
    let Rec = this.AddressList.filter((a: any) => a.id == value);
    if (Rec != null && Rec.length > 0) {
      let Values = Rec[0].id.split("|")
      let Text = Rec[0].text.split("|");
      this.form.controls["dpa_contact_subdistict"].setValue(Values[0].trim());
      this.form.controls["dpa_contact_distict"].setValue(Values[1].trim());
      this.form.controls["dpa_contact_province"].setValue(Values[2].trim());
      this.form.controls["dpa_contact_postcode"].setValue(Values[3].trim());
      this.form.controls["dpa_contact_country"].setValue(Values[4].trim());
      this.form.controls["dpa_contact_subdistictname"].setValue(Text[0].trim());
      this.form.controls["dpa_contact_distictname"].setValue(Text[1].trim());
      this.form.controls["dpa_contact_provincename"].setValue(Text[2].trim());
      this.form.controls["dpa_contact_postcodename"].setValue(Text[3].trim());
      this.form.controls["dpa_contact_countryname"].setValue(Text[4].trim());
    }
    else {
      this.form.controls["dpa_contact_subdistict"].setValue("");
      this.form.controls["dpa_contact_distict"].setValue("");
      this.form.controls["dpa_contact_province"].setValue("");
      this.form.controls["dpa_contact_postcode"].setValue("");
      this.form.controls["dpa_contact_country"].setValue("");
      this.form.controls["dpa_contact_subdistictname"].setValue("");
      this.form.controls["dpa_contact_distictname"].setValue("");
      this.form.controls["dpa_contact_provincename"].setValue("");
      this.form.controls["dpa_contact_postcodename"].setValue("");
      this.form.controls["dpa_contact_countryname"].setValue("");
    }
  }

  CompanyTypeChange(value: any) {
    $("#divDocList").empty();
    let DivContent = '<br />';
    let Rec = this.CompanyTypeList.filter((a: any) => a.dpa_companytypeid == value);
    if (Rec != null && Rec.length > 0) {
      let SeqNo = 1;
      this.form.controls["dpa_companytypeid"].setValue(value);
      this.form.controls["dpa_companytypeidname"].setValue(Rec[0]["dpa_name"]);
      // Rec[0]["dpa_documentgrouplist"].forEach((DocGroup: any) => {
      //   DocGroup["dpa_documentlist"].forEach((Doc: any) => {
      //     DivContent += '<label class="checktable">';
      //     DivContent += ' <input type="checkbox" class="docCheck" value="' + Doc.dpa_documentid + '"><span class="checkmark"></span>';
      //     DivContent += ' <label>' + SeqNo + '. ' + Doc.dpa_name + '</label>';
      //     DivContent += '</label>';
      //     SeqNo++;
      //   });
      // });
      Rec[0]["dpa_documentgrouplist"].forEach((DocGroup: any) => {
        DivContent += '<label class="checktable">';
        DivContent += ' <input type="checkbox" class="docCheck" value="' + DocGroup.dpa_documentgroupid + '"><span class="checkmark"></span>';
        DivContent += ' <label>' + SeqNo + '. ' + DocGroup.dpa_name + '</label>';
        DivContent += '</label>';
        SeqNo++;
      });
    }
    else {
      this.form.controls["dpa_companytypeid"].setValue("");
      this.form.controls["dpa_companytypeidname"].setValue("");
    }
    $("#divDocList").append(DivContent);
    this.DocumentList = [];
    if (Rec[0].dpa_code == "21" || Rec[0].dpa_code == "22" || Rec[0].dpa_code == "23") {
      $("#LabelRegID").addClass("required");
    }
    else {
      $("#LabelRegID").removeClass("required");
    }
  }

  PersonTypeChange(value: any) {
    $("#divDocList").empty();
    let DivContent = '<br />';
    let Rec = this.PersonTypeList.filter((a: any) => a.dpa_personaltypeid == value);
    if (Rec != null && Rec.length > 0) {
      this.form.controls["dpa_personaltypeid"].setValue(value);
      this.form.controls["dpa_personaltypeidname"].setValue(Rec[0]["dpa_name"]);
      let SeqNo = 1;
      // Rec[0]["dpa_documentgrouplist"].forEach((DocGroup: any) => {
      //   DocGroup["dpa_documentlist"].forEach((Doc: any) => {
      //     DivContent += '<label class="checktable">';
      //     DivContent += ' <input type="checkbox" class="docCheck" value="' + Doc.dpa_documentid + '"><span class="checkmark"></span>';
      //     DivContent += ' <label>' + SeqNo + '. ' + Doc.dpa_name + '</label>';
      //     DivContent += '</label>';
      //     SeqNo++;
      //   });
      // });
      Rec[0]["dpa_documentgrouplist"].forEach((DocGroup: any) => {
        DivContent += '<label class="checktable">';
        DivContent += ' <input type="checkbox" class="docCheck" value="' + DocGroup.dpa_documentgroupid + '"><span class="checkmark"></span>';
        DivContent += ' <label>' + SeqNo + '. ' + DocGroup.dpa_name + '</label>';
        DivContent += '</label>';
        SeqNo++;
      });
      $("#dpa_idcard").off("keypress");
      if (Rec[0]["dpa_name"].includes("ต่างชาติ")) {
        $("#IdCardOrPassport").html("เลขพาสปอร์ต");
        $("#LabelBirthDate").addClass("required");
      }
      else {
        $("#IdCardOrPassport").html("เลขบัตรประชาชน");
        $("#LabelBirthDate").removeClass("required");
        let thisTs = this;
        $("#dpa_idcard").on("keypress", function (e: any) {
          return thisTs.NumericKey(e);
        });
      }
    }
    else {
      this.form.controls["dpa_personaltypeid"].setValue("");
      this.form.controls["dpa_personaltypeidname"].setValue("");
    }
    $("#divDocList").append(DivContent);
    this.DocumentList = [];
  }

  SelectDocument(target: any) {
    if (target.checked) {
      if (this.DocumentList == null || this.DocumentList == undefined)
        this.DocumentList = [];
      this.DocumentList.push({
        "dpa_documentid": target.value,
      });
    }
    else {
      this.DocumentList = this.DocumentList.filter((a: any) => a.dpa_documentid != target.value);
    }
  }

  CreateTableFile() {
    let thisTs = this;
    var TableDocs = $('#TableDocs').DataTable({
      "paging": false,
      "bFilter": false,
      "info": false,
      "data": this.FileList,
      "columns": [
        { "data": "filename", "class": "text-center" },
        { "data": "filename" },
        {
          "data": "null",
          "render": function (data: any, type: any, row: any) {
            if (row.filesize / 1024 / 1024 < 1) {
              return Math.floor(row.filesize / 1024) + ' KB';
            }
            else {
              return (Math.round(row.filesize / 1024 / 1024 * 100 + Number.EPSILON) / 100) + ' MB';
            }
          },
          "class": "text-right"
        },
        {
          "data": null,
          "render": function (data: any, type: any, row: any) {
            return '<i class="fa fa-eye editicon cursorpointer" role="view" url="' + row.url + '" filename="' + row.filename + '" title="View"></i>' +
              '<i class="fa fa-times deleteicon cursorpointer" role="delete" filename="' + row.filename + '" title="Delete"></i>';
          },
          "class": "col-btn-2 text-center"
        }
      ],
      "language": {
        "zeroRecords": "ยังไม่ได้อัปโหลดไฟล์"
      }
    });

    // TableDocs.on('click', 'tbody tr td [role=view]', function () {
    //   thisTs.ViewFile($(this).attr('url'), $(this).attr('filename'));
    // });

    // TableDocs.on('click', 'tbody tr td [role=delete]', function () {
    //   thisTs.DeleteFile($(this).attr('filename'));
    // });

    TableDocs.on('order.dt search.dt', function () {
      TableDocs.column(0, { search: 'applied', order: 'applied' }).nodes().each(function (cell: any, i: any) {
        cell.innerHTML = i + 1;
      });
    }).destroy().draw();
  }

  ViewFile(Url: any, FileName: any) {
    if (Url == "") {
      this.Util.ErrorDialog('ไม่พบไฟล์ที่เลือก');
      return;
    }

    window.open(this.Util.CreateBlobUrl(Url), "_blank");

    // $("#FileNameTitle").html(FileName);
    // $("#ViewDocFrame").attr("src", this.Util.CreateBlobUrl(Url));
    // $('#dlgFile').modal();

    // var link = document.createElement('a');
    // link.href = this.Util.CreateBlobUrl(Url);
    // link.target = "_blank";
    // link.download = FileName;
    // link.click();
    // console.log("click!");
  }

  DeleteFile(FileName: any) {
    this.FileList.forEach((item: any, index: any) => {
      if (item["filename"] === FileName)
        this.FileList.splice(index, 1);
    });
    this.CreateTableFile();
  }

  async FileSelect(File: any) {
    if (File.length == 0)
      return;
    var FileName = File[0]["name"];
    var FileExtension = FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length);

    if (!this.AcceptExtension.toLowerCase().includes(FileExtension.toLowerCase())) {
      this.Util.WarningDialog('รองรับเฉพาะไฟล์ ' + this.AcceptExtension);
      $('#fileAttach').val('');
      return;
    }

    var TotalFileSize: number = File[0]["size"];
    this.FileList.forEach((a: any) => {
      TotalFileSize += +a["filesize"];
    });
    if (TotalFileSize / 1024 / 1024 > this.MaxTotalSizeMB) {
      this.Util.WarningDialog('ขนาดไฟล์รวมทั้งหมดต้องไม่เกิน ' + this.MaxTotalSizeMB + " MB");
      $('#fileAttach').val('');
      return;
    }

    if (this.FileList != null) {
      if (this.FileList.filter((a: any) => a.filename == File[0].name).length > 0) {
        this.Util.WarningDialog("ชื่อไฟล์ซ้ำกับไฟล์ที่อัปโหลดแล้ว");
        return;
      }
    }

    var FR = new FileReader();
    var FileContent: any;
    var MimeType: any;
    let thisTs = this;
    FR.onload = (e) => {
      var t: any = e.target;
      FileContent = t.result;
      MimeType = FileContent.substring(FileContent.indexOf(":") + 1, FileContent.indexOf(";"));
      var FileContent2 = FileContent.substring(FileContent.indexOf(",") + 1, FileContent.length);

      if (thisTs.FileList == null || thisTs.FileList == undefined)
        thisTs.FileList = [];
      thisTs.FileList.push({
        "annotationid": null,
        "filename": File[0].name,
        "documentbody": FileContent2,
        "mimetype": MimeType,
        "filesize": File[0]["size"],
        "url": FileContent
      });
      $('#fileAttach').val('');
      // $('#txtFileName').val('');
      thisTs.CreateTableFile();
    };
    FR.readAsDataURL(File[0]);
    // $('#txtFileName').val(File[0]["name"]);
  }

  async UploadFile() {
    var FileInput = $('#fileAttach')[0]["files"];
    if (FileInput.length == 0) {
      this.Util.WarningDialog('กรุณาเลือกไฟล์');
      return;
    }

    if (this.FileList != null) {
      if (this.FileList.filter((a: any) => a.filename == FileInput[0].name).length > 0) {
        this.Util.WarningDialog("ชื่อไฟล์ซ้ำกับไฟล์ที่อัปโหลดแล้ว");
        return;
      }
    }

    var File = new FileReader();
    var FileContent: any;
    var MimeType: any;
    let thisTs = this;
    File.onload = (e) => {
      var t: any = e.target;
      FileContent = t.result;
      MimeType = FileContent.substring(FileContent.indexOf(":") + 1, FileContent.indexOf(";"));
      var FileContent2 = FileContent.substring(FileContent.indexOf(",") + 1, FileContent.length);

      if (thisTs.FileList == null || thisTs.FileList == undefined)
        thisTs.FileList = [];
      thisTs.FileList.push({
        "annotationid": null,
        "filename": FileInput[0].name,
        "documentbody": FileContent2,
        "mimetype": MimeType,
        "filesize": FileInput[0]["size"],
        "url": FileContent
      });
      $('#fileAttach').val('');
      $('#txtFileName').val('');
      thisTs.CreateTableFile();
    };
    File.readAsDataURL(FileInput[0]);
  }

  ShowConsent() {
    $('#dlgAcceptCondition').modal();
  }

  AcceptChange() {
    this.AcceptChecked = $("#Accepted")[0].checked;
    if(!this.isShownConsent){
      this.isShownConsent = true
      this.ShowConsent()
    }
  }

  async Send() {
    var DocGroup: any;
    if (this.Type == CustomerType.Company) {
      if ($("#Type_Company").val() == "") {
        this.Util.WarningDialog("กรุณาเลือกประเภทลูกค้า");
        return;
      }
      DocGroup = this.CompanyTypeList.filter((a: any) => a.dpa_companytypeid == $("#Type_Company").val())[0].dpa_documentgrouplist;
    }
    else {
      if ($("#Type_Person").val() == "") {
        this.Util.WarningDialog("กรุณาเลือกประเภทลูกค้า");
        return;
      }
      DocGroup = this.PersonTypeList.filter((a: any) => a.dpa_personaltypeid == $("#Type_Person").val())[0].dpa_documentgrouplist;
    }
    var IsValid = await this.ValidateInput();
    if (!IsValid)
      return;
    if (!this.ValidateEmail(this.Type == CustomerType.Company ? $("#EMail_Company").val() : $("#EMail_Person").val()))
      return;
    if (!this.ValidateAccNo(this.Type == CustomerType.Company ? $("#AccountNo_Company").val() : $("#AccountNo_Person").val()))
      return;
    if (!this.ValidateTelephone($("#telephone1").val()))
      return;
    if (this.DocumentList.length == 0) {
      this.Util.WarningDialog("กรุณาเลือกประเภทเอกสาร");
      return;
    }
    IsValid = await this.Util.ValidateSelectedDocument(this.DocumentList, DocGroup);
    if (!IsValid)
      return;
    if (this.FileList.length == 0) {
      this.Util.WarningDialog("กรุณาอัปโหลดไฟล์เอกสาร");
      return;
    }

    if (!this.AcceptChecked) {
      this.Util.WarningDialog("กรุณาคลิกเลือกยอมรับนโยบาย");
      return;
    }

    // let thisTs = this;
    // $("#ReceiveNews").prop("checked", false);
    // $("#Accepted").prop("checked", false);
    // $('#dlgAcceptCondition').modal();
    // $("#btnAccept").off('click');
    // $("#btnAccept").click(async function () {
    //   if (!$("#Accepted")[0].checked) {
    //     //thisTs.Util.WarningDialog("กรุณาคลิกเลือกยอมรับนโยบาย");
    //     setTimeout(function () { $("#btnCancel").click(); }, 200);
    //     return;
    //   }

    //   thisTs.Util.ShowWaiting(true);

    //   let TicketNo = await thisTs.CreateContactAndTicket();
    //   if (TicketNo != "") {
    //     console.log(TicketNo);
    //     thisTs.ResetForm();
    //     thisTs.Util.SuccessDialog("ลงทะเบียนยืนยันตัวตนสำเร็จ เลขรับเรื่องคือ " + TicketNo);
    //     setTimeout(function () { $("#btnCancel").click(); }, 200);
    //   }
    //   thisTs.Util.ShowWaiting(false);
    // });

    this.Util.ShowWaiting(true);

    let TicketNo = await this.CreateContactAndTicket();
    if (TicketNo != "") {
      console.log(TicketNo);
      this.ResetForm();
      this.Util.SuccessDialog("ลงทะเบียนยืนยันตัวตนสำเร็จ เลขรับเรื่องคือ " + TicketNo);
      let thisTs = this;
      $('#btnSuccessOK').off('click');
      $('#btnSuccessOK').on('click', function() {
        thisTs.Router.navigate(['/mainmenu/ticketlist']);
      });
    }
    this.Util.ShowWaiting(false);

    $("#ReceiveNews").prop("checked", false);
    $("#Accepted").prop("checked", false);
    this.AcceptChecked = false;
  }

  async CreateContactAndTicket() {
    try {
      var PortalUsername: string;
      if (this.Type == CustomerType.Person) {
        if (this.form.get("dpa_personaltypeidname").value.includes("ต่างชาติ")) {
          this.form.controls["dpa_passport"].setValue(this.form.get("dpa_idcard").value);
          this.form.controls["dpa_idcard"].setValue("");
        }
        else
          this.form.controls["dpa_passport"].setValue("");
        this.form.controls["dpa_accountno"].setValue($("#AccountNo_Person").val());
        this.form.controls["emailaddress1"].setValue($("#EMail_Person").val());

        let dob: string = $('#birthdate').val()

        if (dob == null || dob.trim().length == 0) {
          this.form.controls["birthdate"].setValue("")
        }
        else {
          this.form.controls["birthdate"].setValue($('#birthdate').data('datepicker').date.toISOString())
        }
      }
      else {
        // this.form.controls["dpa_contacttype"].setValue("3");
        this.form.controls["dpa_accountno"].setValue($("#AccountNo_Company").val());
        this.form.controls["emailaddress1"].setValue($("#EMail_Company").val());
        this.form.controls["dpa_authorizedperson"].setValue($("#AuthorizedFirstName").val() + " " + $("#AuthorizedLastName").val());
        this.form.controls["telephone1"].setValue(this.form.get("dpa_authorizedperson_telephone").value);
      }

      // this.PortalLogin = await this.Api.getPortal("user", "getuser", "username=" + this.form.get("emailaddress1").value);
      // if (this.PortalLogin != null && this.PortalLogin.length > 0) {
      //   this.Util.WarningDialog("E-mail '" + this.form.get("emailaddress1").value + "' ถูกใช้งานแล้ว");
      //   if (this.form.get("dpa_passport").value != "")
      //     this.form.controls["dpa_idcard"].setValue(this.form.get("dpa_passport").value);
      //   return '';
      // }

      this.form.controls["dpa_allowemail"].setValue($("#ReceiveNews")[0].checked);
      this.form.controls["dpa_allowsms"].setValue($("#ReceiveNews")[0].checked);

      this.form.controls["dpa_originalsource"].setValue(2);
      this.form.controls["dpa_contactid"].setValue(null);
      this.form.controls["dpa_submitdate"].setValue((new Date()).toISOString());
      var DocList = "";
      this.DocumentList.forEach((a: any) => {
        DocList += (DocList == "" ? "" : "|") + a.dpa_documentid;
      });
      this.form.controls["dpa_documentchecklist"].setValue(DocList);

      let TotalFileSize = 0;
      this.FileList.forEach((a: any) => {
        var Decoded = atob(a.documentbody);
        a.filesize = Decoded.length;
        TotalFileSize += a.filesize;
        a.url = "";
      });
      this.form.controls["attachfilelist"].setValue(this.FileList);
      this.form.controls["dpa_attachsizing"].setValue(TotalFileSize);


      let TicketID = '', ContactID = '';
      this.form.controls["dpa_agentbankflag"].setValue(true)
      this.form.controls["dpa_portalflag"].setValue(false)

      // let code = this.form.controls["dpa_approvalstatuscode"].value
      this.form.controls["dpa_approvalstatusid"].setValue(this.GetStatusGuidByCode("01"))

      var Res: any = await this.Api.post('crmservice', 'approvalTicket', this.form.value);

      if (Res.RESMSG != null && Res.RESMSG != undefined) {
        if (Res.RESMSG == "มีข้อมูลในระบบแล้ว") {
          if (this.form.get("dpa_idcard").value != "") {
            this.Util.WarningDialog("เลขบัตรประชาชนหรือ E-Mail มีอยู่ในระบบแล้ว");
          }
          else if (this.form.get("dpa_passport").value != "") {
            this.Util.WarningDialog("เลขพาสปอร์ตหรือ E-Mail มีอยู่ในระบบแล้ว");
            this.form.controls["dpa_idcard"].setValue(this.form.get("dpa_passport").value);
          }
          else {
            this.Util.WarningDialog("เลขประจำตัวผู้เสียภาษี / เลขนิติบุคคลหรือ E-Mail มีอยู่ในระบบแล้ว");
          }
          return '';
        }
        else if (Res["dpa_name"] == null || Res["dpa_name"] == undefined) {
          this.Util.WarningDialog("ไม่สามารถบันทึกข้อมูลได้");
          return '';
        }
      }

      TicketID = Res["dpa_name"];
      ContactID = Res["contactid"];
      let Contact: any = await this.Api.get("crmservice", "contact", "contactid=" + ContactID);
      Contact = Contact[0];

      if (this.Type == CustomerType.Person) {
        this.PortalLogin = {
          firstname: this.form.get("firstname").value,
          lastname: this.form.get("lastname").value,
          usernameidno: this.form.get("dpa_personaltypeidname").value.includes("ต่างชาติ") ? this.form.get("dpa_passport").value : this.form.get("dpa_idcard").value,
          username: this.form.get("emailaddress1").value,
          password: '',
          passwordold1: '',
          isactive: "1",
          customerid: ContactID,
          createOn: null,
          createBy: localStorage.getItem("AgentBank_Profile"),
          pid: null,
          modifiedOn: null,
          modifiedBy: null
        };
      }
      else {
        this.PortalLogin = {
          firstname: $("#AuthorizedFirstName").val(),
          lastname: $("#AuthorizedLastName").val(),
          usernameidno: Contact.dpa_registrationid,
          username: this.form.get("emailaddress1").value,
          password: '',
          passwordold1: '',
          isactive: "1",
          customerid: ContactID,
          createOn: null,
          createBy: localStorage.getItem("AgentBank_Profile"),
          pid: null,
          modifiedOn: null,
          modifiedBy: null
        };
      }
      this.PortalLogin.dpa_agentbankuserid = localStorage.getItem("AgentBank_UserID");
      this.PortalLogin.call_by = "3";
      this.PortalLogin.url = environment.webPortalUrl;
      // this.PortalLogin.username = this.form.get("emailaddress1").value;
      // this.PortalLogin.password = '';
      // this.PortalLogin.passwordold1 = '';
      // this.PortalLogin.isactive = "1";
      // this.PortalLogin.customerid = ContactID;
      // this.PortalLogin.createOn = null;
      // this.PortalLogin.createBy = localStorage.getItem("AgentBank_Profile");
      // this.PortalLogin.pid = null;
      // this.PortalLogin.modifiedOn = null;
      // this.PortalLogin.modifiedBy = null;
      Res = await this.Api.postPortal("user", "InsertUser", this.PortalLogin);
      console.log(Res);

      // let Token: any = {
      //   username: this.PortalLogin.username,
      //   usernameidno: this.PortalLogin.usernameidno,
      //   usertype: this.Type == CustomerType.Person ? "1" : "2",
      //   createBy: localStorage.getItem("AgentBank_Profile"),
      //   firstname: this.PortalLogin.firstname,
      //   lastname: this.PortalLogin.lastname,
      //   ticketNo: TicketID,
      //   call_by: "3",
      //   url: this.Util.baseUrl()
        
      // };
      // Res = await this.Api.postPortal("user", "CreateToken", Token);
      // if (Res != null) {
      //   Res = await this.SendEmail(Res.token_id, TicketID);
      // }
      // console.log(Res);

      this.ResetForm();
      return TicketID;
    }
    catch (err) {
      console.log(err);
      this.Util.ErrorDialog("บันทึกข้อมูลไม่สำเร็จ");
      if (this.form.get("dpa_passport").value != "")
        this.form.controls["dpa_idcard"].setValue(this.form.get("dpa_passport").value);
      return '';
    }
  }

  async SendEmail(TokenID: any, TicketNo: any) {
    let MailObj: any = {
      contactid: this.PortalLogin.customerid,
      dpa_name: this.PortalLogin.firstname + " " + this.PortalLogin.lastname
    };

    let portUtl = await this.Api.getConfig(6)
    var MailContent = "เรียน คุณ" + this.PortalLogin.firstname + " " + this.PortalLogin.lastname + "<br /><br />" +
      "   คุณได้ลงทะเบียนเพื่อเข้าใช้งานระบบ Customer Web Portal ของสถาบันคุ้มครองเงินฝาก <br />" +
      "รหัสผู้ใช้งานของคุณคือ : " + this.PortalLogin.usernameidno + " เลขที่รับเรื่อง: " + TicketNo + "<br />" +
      " โปรดคลิกลิงค์ด้านล่างเพื่อตั้งรหัสผ่าน <br /><br />" +
      "<a href='" + portUtl + "/resetpassword?id=" + TokenID + "'>" +
      portUtl + "/resetpassword?id=" + TokenID + "</a><br /><br />" +
      "ขอแสดงความนับถือ <br />" +
      "สถาบันคุ้มครองเงินฝาก <br />" +
      "อาคารเอสเจ อินฟินิท วัน บิสซิเนสคอมเพล็กซ์ <br />" +
      "ชั้น 25-27 เลขที่ 349 ถนนวิภาวดีรังสิต <br />" +
      "แขวงจอมพล เขตจตุจักร กรุงเทพฯ 10900 <br />" +
      "โทร : 02-272-0300";
    MailObj.dpa_description = MailContent;
    MailObj.dpa_callby = 3
    let Res = await this.Api.post("crmservice", "sendEmail", MailObj);
    return Res;
  }

  async CreateTicket(ContactID: any) {
    try {
      this.ticket.controls["dpa_contactid"].setValue(ContactID);
      this.ticket.controls["dpa_submitdate"].setValue(new Date().toISOString());
      var DocList = "";
      this.DocumentList.forEach((a: any) => {
        DocList += (DocList == "" ? "" : "|") + a.dpa_documentid;
      });
      this.ticket.controls["dpa_documentchecklist"].setValue(DocList);
      this.ticket.controls["attachfilelist"].setValue(this.FileList);
      this.ticket.controls["dpa_attachsizing"].setValue("0");

      // let code = this.ticket.controls["dpa_approvalstatuscode"].value
      this.ticket.controls["dpa_approvalstatusid"].setValue(this.GetStatusGuidByCode("01"))

      let TicketNo = '';
      var Res: any = await this.Api.post('crmservice', 'approvalticket', this.ticket.value);
      TicketNo = Res["dpa_name"];

      let Token: any = {
        username: this.PortalLogin.username,
        usernameidno: this.PortalLogin.usernameidno,
        usertype: this.Type == CustomerType.Person ? "1" : "2",
        createBy: localStorage.getItem("AgentBank_Profile"),
        contactid: Res["contactid"]
      };
      Res = await this.Api.postPortal("user", "CreateToken", Token);
      if (Res != null) {
        Res = await this.SendEmail(Res.token_id, TicketNo);
      }
      console.log(Res);

      return TicketNo;
    }
    catch (err) {
      console.log(err);
      this.Util.ErrorDialog("บันทึกข้อมูลไม่สำเร็จ");
      return '';
    }
  }

  ResetForm() {
    let thisTs = this;
    this.form.reset();
    $("#AccountNo_Person").val("");
    $("#EMail_Person").val("");
    $("#birthdate").val("");
    $("#AccountNo_Company").val("");
    $("#EMail_Company").val("");
    $("#AuthorizedLastName").val("");
    $("#AuthorizedFirstName").val("");
    $("#SelectAddress").val("").trigger("change");
    this.FileList = [];
    this.DocumentList = [];
    this.CreateTableFile();
    if (this.Type == CustomerType.Person)
      this.PersonTypeChange($("#Type_Person").val());
    else
      this.CompanyTypeChange($("#Type_Company").val());
    $('.docCheck').on("change", function (e: any) {
      thisTs.SelectDocument(e.target);
    });
  }

  async ValidateInput() {
    let MissRequiredField = false;
    if (this.Type == CustomerType.Person) {
      let IsForeigner = true;
      if (!this.form.get("dpa_personaltypeidname").value.includes("ต่างชาติ")) {
        if (this.form.get("dpa_idcard").value != null && this.form.get("dpa_idcard").value != "" && !this.Util.ValidateCitizenID(this.form.get("dpa_idcard").value)) {
          this.Util.WarningDialog("เลขบัตรประชาชนไม่ถูกต้อง");
          return false;
        }
        IsForeigner = false;
      }
      MissRequiredField = this.form.get("firstname").value == "" || this.form.get("firstname").value == null ||
        this.form.get("lastname").value == "" || this.form.get("lastname").value == null ||
        this.form.get("dpa_idcard").value == "" || this.form.get("dpa_idcard").value == null ||
        $("#AccountNo_Person").val() == "" || $("#AccountNo_Person").val() == null ||
        $("#EMail_Person").val() == "" || $("#EMail_Person").val() == null ||
        this.form.get("telephone1").value == "" || this.form.get("telephone1").value == null ||
        (IsForeigner && this.form.get("birthdate").value == "");
    }
    else {
      if (this.form.get("dpa_authorizedperson_idcard").value != "" && this.form.get("dpa_authorizedperson_idcard").value != null && !this.Util.ValidateCitizenID(this.form.get("dpa_authorizedperson_idcard").value)) {
        this.Util.WarningDialog("เลขบัตรประชาชนไม่ถูกต้อง");
        return false;
      }
      let CompanyTypeCode = this.CompanyTypeList.filter((a: any) => a.dpa_companytypeid == this.form.get("dpa_companytypeid").value)[0].dpa_code;
      MissRequiredField = this.form.get("dpa_companyname").value == "" || this.form.get("dpa_companyname").value == null ||
        this.form.get("dpa_authorizedperson_idcard").value == "" || this.form.get("dpa_authorizedperson_idcard").value == null ||
        this.form.get("dpa_authorizedperson_telephone").value == "" || this.form.get("dpa_authorizedperson_telephone").value == null ||
        $("#AuthorizedFirstName").val() == "" || $("#AuthorizedFirstName").val() == null ||
        $("#AuthorizedLastName").val() == "" || $("#AuthorizedLastName").val() == null ||
        $("#AccountNo_Company").val() == "" || $("#AccountNo_Company").val() == null ||
        $("#EMail_Company").val() == "" || $("#EMail_Company").val() == null ||
        ((CompanyTypeCode == "21" || CompanyTypeCode == "22" || CompanyTypeCode == "23") &&
          (this.form.get("dpa_registrationid").value == null || this.form.get("dpa_registrationid").value == ""));
    }
    MissRequiredField = MissRequiredField || $("#SelectAddress").val() == null || $("#SelectAddress").val() == "";

    if (MissRequiredField) {
      this.Util.WarningDialog("กรุณาระบุข้อมูลบังคับ (*) ให้ครบถ้วน");
      return false;
    }
    return true;
  }

  GoBackHome() {
    this.Router.navigate(["/mainmenu/ticketlist"]);
  }

  ValidateTelephone(Value: any) {
    for (var i: number = 0; i < Value.length; i++) {
      if (isNaN(Value[i]) && Value[i] != "-" && Value[i] != ",") {
        this.Util.WarningDialog("หมายเลขโทรศัพท์ไม่ถูกต้อง")
        return false;
      }
    }
    return true;
  }

  TelephoneKey(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {

      if (charCode == 35 || charCode == 44 || charCode == 45) {
        return true
      }
      return false;
    }
    return true;
  }

  NumericKey(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  ValidateEmail(Value: any) {
    let Match = Value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
    if (!Match) {
      this.Util.WarningDialog("E-Mail ไม่ถูกต้อง")
    }
    return Match;
  }

  ValidateAccNo(Value: any) {
    for (var i: number = 0; i < Value.length; i++) {
      if (isNaN(Value[i])) {
        this.Util.WarningDialog("เลขที่บัญชีไม่ถูกต้อง")
        return false;
      }
    }
    return true;
  }

  GetStatusGuidByCode(code: string){
    let found: any = this.masterStatus.filter((s:any) => {
      return s.dpa_code == code
    })

    if(found != null && found.length > 0){
      return found[0].dpa_approvalstatusid
    }
    else{
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/profile-register/profile-register.component.ts